<template>
  <div class="app-friend-notification">
    <div class="container-box">
      <div class="content-limiter">
        <div class="friend-box-wrapper">
          <slot name="txtHeadline"><h2 class="text-3xl">Freunde werben Freunde</h2></slot>
          <slot name="txtBefore"></slot>

          <div class="friend-box">
            <img src="/files/lidl/images/new-icons/svg/friends.svg" alt="" />

            <div class="text-base-semibold friend-box-text friend-box-price">5 <abbr title="Euro">€</abbr> Rabatt</div>
            <div class="text-sm text-base-semibold">Freunde werben</div>
          </div>
          <slot name="txtAfter">
            <p class="text-base">
              Du wurdest von einem Freund geworben? Falls ja, gib hier deine
              <span class="uppercase">Lidl</span>
              <span lang="en">Connect</span> Rufnummer ein und sichtert euch beide 5 <abbr title="Euro">€</abbr> Guthaben.
            </p></slot
          >

          <div>
            <div class="input-field">
              <label class="text-base-semibold">
                <slot name="txtLabel">Rufnummer</slot>
              </label>
              <input
                id="friend-msisdn"
                name="msisdn"
                type="text"
                v-model.trim="msisdn_"
                :class="{ 'input-error': !isValid('msisdn') }"
                @input="$v.msisdn.$touch"
                class="input"
                placeholder="Rufnummer hier eingeben"
              />
            </div>

            <div class="captcha-wrapper">
              <captcha ref="captchaComponent" @captchaCode="updateCaptchaData"></captcha>
              <div class="message-box-v2 info-box --success" v-if="successState">
                <span class="text-sm">
                  <slot name="txtIsSuccess">SUCCESS</slot>
                </span>
              </div>
              <div class="message-box-v2 info-box --danger" v-if="!successState && message">
                <span class="text-sm" v-html="message"></span>
              </div>
              <div class="button-confirm">
                <button @click="check" type="button" class="button button--secondary">
                  Jetzt prüfen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import syncProperty from '@/mixins/syncProperty'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { helpers } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/isValid'
import Captcha from '@/components-v2/flows/LIDL/Cancellation/Captcha'
import { required } from 'vuelidate/src/validators'

const isPhoneNumber = helpers.regex('phoneNumber', /^[+]?[0-9]*$/)

export default {
  name: 'FriendNotification',
  components: { Captcha },
  data() {
    return {
      loading: false,
      showMessageBox: false,
      message: '',
      successState: false,
      captcha: {
        token: '',
        code: ''
      },
      captchaEmpty: true
    }
  },
  updated() {
    this.updateCaptchaData({
      captchaCode: this.$refs.captchaComponent.captchaCode,
      captchaToken: this.$refs.captchaComponent.captcha.token
    })
  },
  computed: {
    ...mapGetters('activation/info', {
      newCutomer: 'msisdn'
    }),
    loading_: function() {
      return this.loading
    },
    captchaEmpty_: function() {
      return this.captchaEmpty
    }
  },
  mixins: [syncProperty('msisdn', 'msisdn_'), validationMixin, isValid],
  props: {
    processName: String
  },
  validations() {
    return {
      msisdn: {
        isPhoneNumber,
        required
      }
    }
  },
  methods: {
    ...mapActions('friendNotification', ['checkReferFriend']),
    ...mapMutations('friendNotification', ['existingCustomerMsisdn']),
    ...mapMutations('friendNotification', {
      updateStoreCaptcha: 'captcha'
    }),
    setMessage(checkReferFriend) {
      this.showMessageBox = true
      if (checkReferFriend.success) {
        this.successState = true
      } else {
        this.message = checkReferFriend
        this.successState = false
      }
    },
    checkProcess() {
      if (this.processName === 'friendNotification') {
        return {
          newCustomerMsisdn: this.msisdn_,
          processName: this.processName,
          captcha: this.captcha
        }
      } else {
        return {
          existingCustomerMsisdn: this.msisdn_,
          newCustomerMsisdn: this.newCutomer,
          processName: this.processName,
          captcha: this.captcha
        }
      }
    },
    check() {
      this.loading = true
      if (this.msisdn_ !== '' && !this.captchaEmpty_) {
        const me = this
        this.checkReferFriend(me.checkProcess()).then(checkReferFriend => {
          this.showMessageBox = true
          this.setMessage(checkReferFriend)
          if ((typeof checkReferFriend).toLowerCase() !== 'object' || !checkReferFriend.success) {
            this.reloadCaptchaComponent()
          }
          this.loading = false
        })
      } else {
        this.existingCustomerMsisdn(this.msisdn_)
        this.loading = false
      }
    },
    updateCaptchaData(captchaData) {
      this.captcha.code = captchaData.captchaCode
      this.captcha.token = captchaData.captchaToken
      this.$emit('updatedCaptcha', this.captcha)
      this.updateStoreCaptcha(this.captcha)
      this.captchaEmpty = this.captcha.code === ''
    },
    reloadCaptchaComponent() {
      this.$refs.captchaComponent.$apollo.queries.captcha.refresh()
      this.$refs.captchaComponent.captchaCode = ''
      this.updateCaptchaData({
        captchaCode: this.$refs.captchaComponent.captchaCode,
        captchaToken: this.$refs.captchaComponent.captcha.token
      })
    }
  }
}
</script>
